import React from "react";

export default function FooterLinks() {
  return (
    <div className="flex items-end gap-4 mt-8">
      <div className="flex flex-col gap-[6px] items-end">
        <span className=" font-Helvetica text-[13px] cursor-pointer text-white uppercase">
          whitepaper
        </span>
        <span className=" font-Helvetica text-[13px] cursor-pointer text-white uppercase">
          Roadmap
        </span>
      </div>
      <div className="flex flex-col gap-[6px] cursor-pointer items-end">
        <span className=" font-Helvetica text-[13px] text-white uppercase">
          contact
        </span>
        <span className=" font-Helvetica text-[13px] cursor-pointer text-white uppercase">
          partnerships
        </span>
        <span className=" font-Helvetica text-[13px] cursor-pointer text-white uppercase">
          tokenomics
        </span>
      </div>
    </div>
  );
}
